import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';

// components

import { PaginationComponent } from "./pagination/pagination.component";
import { DialogBoxComponent } from "./dialog-box/dialog-box.component";
import { TableLoadingComponent } from './table-loading/table-loading.component';

// import other lib
import { ContentLoaderModule } from "@ngneat/content-loader";
import {
  NgbPaginationConfig,
  NgbPaginationModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { ActionBtnGpComponent } from './action-btn-gp/action-btn-gp.component';

const components = [
  PaginationComponent,
  DialogBoxComponent,
  TableLoadingComponent,
  ActionBtnGpComponent
];
@NgModule({
  declarations: [components,],
  imports: [
    CommonModule,
     NgbPaginationModule,
      NgbTooltipModule,
     ContentLoaderModule,
    FormsModule,
  ],
  exports: [components],
  providers:[
  ]
})
export class TableModule {}
